export const ERROR_POPUP = {
  GROUP_CREATE_LIMIT: 'groupCreateLimit',
  INVALID_IMAGE_FORMAT_UPLOAD: 'invalidImageFormatUpload',
  FILE_SIZE_OVER_MAX_LIMIT: 'fileSizeOverMaxLimit',
  FILE_DIMENSION_OVER_MAX_LIMIT: 'fileDimensionOverMaxLimit',
  IMAGE_CONTAIN_BANNED_URL: 'imageContainBannedUrl',
}
